export const raccordementFields = {
    connectedNetwork: null,
    epConnectedPublicSanitationNetwork: null,
    connections: [],
};
